export default "__VITE_ASSET__9su_UzqR__"